import { render, staticRenderFns } from "./index.vue?vue&type=template&id=610cf1ce&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610cf1ce')) {
      api.createRecord('610cf1ce', component.options)
    } else {
      api.reload('610cf1ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=610cf1ce&", function () {
      api.rerender('610cf1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contract-prepay/index.vue"
export default component.exports